import React from "react";

import SpLink from "../../../shared/SpLink";
import PollenLogo from "../PollenLogo";

import styles from "./SpPollenDualLogo.module.scss";

type SpPollenDualLogoType = {
  className?: string;
};

const SpPollenDualLogo: React.FC<SpPollenDualLogoType> = ({ className }) => (
  <div
    className={`${styles.spPollenDualLogo} ${className}`}
    data-testid="nav-dual-logo"
  >
    <SpLink path="/" className={styles.spLogoLink}>
      <svg className={styles.spLogo}>
        <use href="/icons/sp-logo.svg#sp-new-logo-sm"></use>
      </svg>
    </SpLink>

    <svg className={styles.divider}>
      <use href="/icons/divider.svg#vertical"></use>
    </svg>

    <PollenLogo />
  </div>
);

export default SpPollenDualLogo;
